"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unclickable = exports.trimSpacesAndPeriods = exports.pickRandomValueFromArray = exports.normalize = exports.hasExpirationDatePassed = exports.getUserTitle = exports.getPackageTransferStateText = exports.getPercentComplete = exports.getAllRecipientsFromPackage = exports.getAllRecipients = exports.clearHasbroSessionStorageKeys = exports.isDirectory = exports.splitEmails = exports.numToWords = exports.isInternalEmail = exports.decodeJwt = exports.containsEmoji = exports.megabytesToBytes = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var emoji_regex_1 = __importDefault(require("emoji-regex"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var moment_1 = __importDefault(require("moment"));
var config_1 = require("./config");
var models_1 = require("@app/_state/models");
var constants_1 = require("@server/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var utils_1 = require("@server/shared/utils");
var api_1 = require("@server/types/api");
var megabytesToBytes = function (megaBytes) {
    return megaBytes * (1024 * 1024.0);
};
exports.megabytesToBytes = megabytesToBytes;
var containsEmoji = function (text) {
    if (text) {
        var regex = new RegExp(emoji_regex_1.default());
        return regex.test(text);
    }
    return false;
};
exports.containsEmoji = containsEmoji;
var decodeJwt = function (jwt) {
    return jwt_decode_1.default(jwt);
};
exports.decodeJwt = decodeJwt;
var isInternalEmail = function (email) {
    if (!email) {
        return false;
    }
    return config_1.Config.VALIDATE_EMAIL_REGEX.test(email.toLowerCase());
};
exports.isInternalEmail = isInternalEmail;
/**
 * Convert an integer to its words representation
 *
 * @author McShaman (http://stackoverflow.com/users/788657/mcshaman)
 * @source http://stackoverflow.com/questions/14766951/convert-digits-into-words-with-javascript
 * @modified SKuby
 */
var numToWords = function (num) {
    var units = [
        '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
        'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
    ];
    var tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    var scales = [
        '', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion',
        'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quatttuor-decillion',
        'quindecillion', 'sexdecillion', 'septen-decillion', 'octodecillion', 'novemdecillion', 'vigintillion', 'centillion'
    ];
    if (num === 0) {
        return 'zero';
    }
    else if (num < 20) {
        return units[num];
    }
    else {
        var chunks = [];
        var numStr = num.toString();
        var start = numStr.length;
        while (start > 0) {
            var end = start;
            chunks.push(numStr.slice((start = Math.max(0, start - 3)), end));
        }
        if (chunks.length > scales.length) {
            return '';
        }
        var word = void 0;
        var words = [];
        for (var i = 0; i < chunks.length; i++) {
            var chunk = parseInt(chunks[i], 10);
            if (chunk) {
                /* Split chunk into array of individual integers */
                var ints = chunks[i].split('').reverse().map(parseFloat);
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if (ints[1] === 1) {
                    ints[0] += 10;
                }
                /* Add scale word if chunk is not zero and array item exists */
                if ((word = scales[i])) {
                    words.push(word);
                }
                /* Add unit word if array item exists */
                if ((word = units[ints[0]])) {
                    words.push(word);
                }
                /* Add tens word if array item exists */
                if ((word = tens[ints[1]])) {
                    words.push(word);
                }
                /* Add 'and' string after units or tens integer if: */
                if (ints[0] || ints[1]) {
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if (ints[2] || !i && chunks.length) {
                        words.push('and');
                    }
                }
                /* Add hundreds word if array item exists */
                if ((word = units[ints[2]])) {
                    words.push(word + ' hundred');
                }
            }
        }
        return words.reverse().join(' ');
    }
};
exports.numToWords = numToWords;
var splitEmails = function (value) {
    // Replace all caret (<, >) and newlines with semicolons
    value = value.replace(/[<>()\n\r]/g, ';');
    // Split emails by space, comma, semicolon on pipe symbol
    var emails = value.split(/[\s,;|]/).map(function (e) { return e.trim(); });
    // Only return valid emails
    return emails.filter(function (e) { return utils_1.isEmail(e); });
};
exports.splitEmails = splitEmails;
/**
 * Checks if a file object is a directory
 * @param file
 */
var isDirectory = function (file) {
    return new Promise(function (res, rej) {
        if (file.type) {
            return res(false);
        }
        else {
            try {
                var reader = new FileReader();
                reader.onerror = function (e) {
                    // may be a directory
                    res(true);
                };
                reader.onload = function (e) {
                    // may be a file
                    res(false);
                };
                reader.readAsDataURL(file);
            }
            catch (e) {
                // may be a directory
                res(true);
            }
        }
    });
};
exports.isDirectory = isDirectory;
/**
 * Clear all session storage objects with a key that starts with "hsb-""
 */
var clearHasbroSessionStorageKeys = function () {
    var keyIdx = sessionStorage.length;
    while (keyIdx--) {
        var key = sessionStorage.key(keyIdx);
        if (key && /hsb-/.test(key)) {
            sessionStorage.removeItem(key);
        }
    }
};
exports.clearHasbroSessionStorageKeys = clearHasbroSessionStorageKeys;
/**
 * Collect all the recipients of a package in a semicolon separated string
 */
var getAllRecipients = function (recipients) {
    var recipientsString = [];
    for (var _i = 0, recipients_1 = recipients; _i < recipients_1.length; _i++) {
        var r = recipients_1[_i];
        recipientsString.push(r.userEmail);
    }
    return recipientsString.join(';');
};
exports.getAllRecipients = getAllRecipients;
var getAllRecipientsFromPackage = function (pkg) {
    return exports.getAllRecipients(pkg.recipients);
};
exports.getAllRecipientsFromPackage = getAllRecipientsFromPackage;
/**
 * Calculate transfer percentage complete
 * @param transferredBytes
 * @param totalBytes
 */
var getPercentComplete = function (transferredBytes, totalBytes) {
    // If the total transferred bytes is more than the total size, return 100% for the sake of simplicity
    transferredBytes = transferredBytes > totalBytes ? totalBytes : transferredBytes;
    var value = totalBytes === 0 ? 0 : ((transferredBytes / totalBytes) * 100);
    return value.toFixed(0) + '%';
};
exports.getPercentComplete = getPercentComplete;
/**
 * Returns a human friendly string representation of the current transfer state, ex: Downloading, Failed
 * @param state The current transfer state
 * @param direction Whether upload or download
 */
var getPackageTransferStateText = function (direction, state, completeTransfer) {
    switch (state) {
        case models_1.PackageTransferState.IN_PROGRESS:
            // if (completeTransfer) {
            //   return 'Complete';
            // }
            return direction === api_1.Direction.RECEIVE ? 'Downloading' : 'Uploading';
        case models_1.PackageTransferState.FAILED:
            return 'Failed';
        case models_1.PackageTransferState.COMPLETE:
            return 'Complete';
        case models_1.PackageTransferState.QUEUED:
            return 'Queued';
        case models_1.PackageTransferState.REMOVED:
            return completeTransfer ? 'Complete' : 'Removed';
        case models_1.PackageTransferState.WILLRETRY:
        case models_1.PackageTransferState.STOPPED:
            return 'Stopped';
        default:
            return 'Unknown';
    }
};
exports.getPackageTransferStateText = getPackageTransferStateText;
var getUserTitle = function (user) {
    if (user.lastName.toLowerCase() === constants_1.EXTERNAL_EMAIL) {
        return user.firstName + " (pending)";
    }
    else if (user.lastName.toLowerCase() === 'workgroup' || user.lastName.toLowerCase() === 'dropbox') {
        return "" + user.lastName;
    }
    else {
        return user.firstName + " " + user.lastName;
    }
};
exports.getUserTitle = getUserTitle;
/**
 * Return whether an expiration date has passed or not
 * @param expirationDate
 */
var hasExpirationDatePassed = function (expirationDate) {
    return moment_1.default(expirationDate).diff(moment_1.default.now(), 'seconds') <= 0;
};
exports.hasExpirationDatePassed = hasExpirationDatePassed;
// Normalizes a string and returns it in lower case, used for case-insensitivity comparisons
var normalize = function (s) { return s.normalize('NFKC').toLocaleLowerCase(); };
exports.normalize = normalize;
var pickRandomValueFromArray = function (arr) {
    if (!arr) {
        return '';
    }
    if (arr.length === 1) {
        return arr[0];
    }
    var randomNum = Math.floor(Math.random() * arr.length);
    log_1.default.debug("Picked random number '" + randomNum + "' from array length '" + arr.length + "': " + arr[randomNum]);
    return arr[randomNum];
};
exports.pickRandomValueFromArray = pickRandomValueFromArray;
var trimSpacesAndPeriods = function (str) {
    return str.replace(/^[.\s]+|[.\s]+$/g, '');
};
exports.trimSpacesAndPeriods = trimSpacesAndPeriods;
var unclickable = function (event) {
    event.stopPropagation();
};
exports.unclickable = unclickable;
